import $ from "jquery";
import detectScreenArea from "./detectScreenArea";

const $circle = $(".circle");
const $follow = $(".circle-follow");
const $text = document.createElement("span");
$follow.append($text);

function customCursor(e) {
    if (detectScreenArea(e) === "left") {
        if ($follow.find("span").text() !== "left") {
            $follow.text("prev");
        }
    } else if (detectScreenArea(e) === "right") {
        if ($follow.find("span").text() !== "right") {
            $follow.text("next");
        }
    } else {
        gsap.to($follow, {
            duration: 0.7,
            scale: 0,
            opacity: 0,
        });
    }

    if (detectScreenArea(e) !== "center") {
        gsap.to($follow, {
            duration: 0.7,
            scale: 1,
            opacity: 1,
            x: e.clientX,
            y: e.clientY,
            zIndex: 9999,
        });
    }

    gsap.to($circle, {
        duration: 0.3,
        scale: 1,
        opacity: 1,
        x: e.clientX,
        y: e.clientY,
        zIndex: 9999,
    });
}

function hoverFunc(e) {
    gsap.to($circle, {
        duration: 0.3,
        opacity: 0,
        scale: 0,
        ease: Linear.easeInOut,
    });
    gsap.to($follow, {
        duration: 0.3,
        scale: 0,
        ease: Linear.easeInOut,
    });
}

function unhoverFunc(e) {
    gsap.to($circle, {
        duration: 0.3,
        opacity: 1,
        scale: 1,
        ease: Linear.easeInOut,
    });
    gsap.to($follow, {
        duration: 0.3,
        scale: 1,
        opacity: 1,
        ease: Linear.easeInOut,
    });
}

$("a, .button, #dot-navigation-wrapper").hover(hoverFunc, unhoverFunc);

export default customCursor;
